/*
 * Public API Surface of angular-ace
 */

 export * from './lib/components/ace.component';
 export * from './lib/ace.module';
